import { Component, ViewChild, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter  } from '@angular/core';
import GatewayDto  from '../../dto/gateway-dto';
var $ = require('jquery');

@Component({
  selector: 'gateway-cli-settings',
  template: require('./gateway-cli-settings.html'),
  styles: [require('./gateway-cli-settings.scss')]
})

export default class GatewayCLISettings implements OnChanges{
  @Input('gateway') gateway: GatewayDto;
  @Output('onCliSettingsFormValid') formValid = new EventEmitter();

  public sshStatusLabel: string;
  public confirmPassword: string;

  @ViewChild('cliSettingsForm') form;

  constructor() {
  }

  changeSSHAccess(event){
    this.gateway.cliSettings.remoteAccess = !this.gateway.cliSettings.remoteAccess;
    this.fixSSHLabel();
  }

  ngOnChanges(change: SimpleChanges) {
    this.fixSSHLabel();
  }

  fixSSHLabel() {
    if (this.gateway.cliSettings.remoteAccess) {
      this.sshStatusLabel = 'Activated';
    } else {
        this.sshStatusLabel = 'Deactivated';
    }
  }

  ngAfterViewInit() {
    this.form.control.valueChanges
    .subscribe(values => this.isFormValid(values));
  }

  isPasswordPatternValid(value) {
    let patternPwdValue = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\\\,\"\'\=\_\:\;\~\`\|\$\.\+\/\-\%\<\>\?\&\^\[\]\{\}\*\(\)])/;
    let patternPwdValueValid = patternPwdValue.test(value);
    return patternPwdValueValid;
  }

  checkUserPwdValid(value) {
    if (value && $.trim(value) != '') {
      return this.isPasswordPatternValid(value);
    } else {
      return true;
    }
  }

  isFormValid(values) {
    let isFormValid: boolean;
    if ((!values.username || values.username === '') &&
        (!values.password || values.password === '' ) &&
        (!values.confirmPassword || values.confirmPassword === '')) {
        isFormValid = true;
    } else {
        isFormValid = this.form.valid;
    }
    if (isFormValid && $.trim(values.password) != "") {
      isFormValid = isFormValid && this.isPasswordPatternValid(values.password);
    }
    this.formValid.emit(
      {
        'isValid': isFormValid
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-cli-settings.component.ts